import React from "react";
import moduleStyle from "./Columns.module.css";
import EditIcon from "@material-ui/icons/EditOutlined";
import { VARIANT_TYPE_IDS } from "features/OfferingVariations/OfferingVariations.constants";
import { useOfferingVariationListStore } from "../../store/useOfferingVariationList.store";
import { useOfferingVariations } from "features/OfferingVariations/utils/hooks/useOfferingVariations";
import { KycRowActionsMenu } from "features/ManageOfferings/modules/PerTierKyc/KycRowActionsMenu";

export const ActionField = ({ record }) => {
  const offeringUuid = useOfferingVariationListStore(
    (state) => state.offeringUuid
  );
  const setSelectedVariation = useOfferingVariationListStore(
    (state) => state.setSelectedVariation
  );
  const setShowDeleteModal = useOfferingVariationListStore(
    (state) => state.setShowDeleteModal
  );
  const setIsOpenKycModal = useOfferingVariationListStore(
    (state) => state.setIsOpenKycModal
  );
  const isEnabled = useOfferingVariationListStore((state) => state.isEnabled);
  const showKycColumn = useOfferingVariationListStore(
    (state) => state.showKycColumn
  );
  const { provider } = useOfferingVariations({ offeringUuid });
  const { handleEditVariation } = provider;

  return (
    <div className={`d-flex align-items-center`}>
      {!record.has_bookings && (
        <EditIcon
          onClick={() => {
            handleEditVariation(record);
          }}
          className={`${moduleStyle.editIcon} mr-3`}
        />
      )}
      <KycRowActionsMenu
        disabled={!isEnabled}
        showKycItem={showKycColumn}
        showDelete={record.variant_type === VARIANT_TYPE_IDS.others}
        onKycClick={() => {
          if (!isEnabled) return;
          setSelectedVariation(record);
          setIsOpenKycModal(true);
        }}
        onDeleteClick={() => {
          if (!isEnabled) return;
          setSelectedVariation(record);
          setShowDeleteModal(true);
        }}
      />
    </div>
  );
};
